import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import moment from 'moment'
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ReferenceLine } from 'recharts'
import AverageAttendanceActions from '../../Data/Redux/AverageAttendanceRedux'
import CustomizedLegend from '../../Components/ReportsComponents/CustomizedLegend'
import ReportTemplate from './ReportTemplate'
import CentersInfoActions from '../../Data/Redux/CentersInfoRedux'
import CentersExcelActions from '../../Data/Redux/CentersExcelRedux'

class AvgAttendance extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: 0,
      data: [],
    }
  }

  componentWillMount() {
    const { match, activeCenter, getCentersInfo, setCenter } = this.props
    if (this.props.fromCenter) {
      if (match.params) {
        setCenter(match.params.centerId)
        getCentersInfo(match.params.centerId, 'attendance')
      } else if (activeCenter !== 0) {
        getCentersInfo(activeCenter, 'attendance')
      }
    } else {
      this.props.getAverageAttendance()
    }
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillReceiveProps(nextProps) {
    const newState = { ...this.state }
    const data = []
    const { attendance, centersInfo } = nextProps
    if (attendance.avg_attendance) {
      Object.keys(attendance.avg_attendance).map((att) => {
        const item = { date: att, formatDay: moment(att).format('MMM DD') }
        Object.keys(attendance.avg_attendance[att]).map((key) => {
          if (key === 'total_enrolled') {
          item['Ocupación'] = attendance.avg_attendance[att][key]
          }
          item['Asistencia'] = attendance.avg_attendance[att][key]
        })
        data.push(item)
      })
      this.setState({ data })
    }
    if (centersInfo.avg_attendance) {
      Object.keys(centersInfo.avg_attendance.avg_attendance).map((att) => {
        const item = { date: att, formatDay: moment(att).format('MMM DD') }
        Object.keys(centersInfo.avg_attendance.avg_attendance[att]).map((key) => {
          if (key === 'total_enrolled') {
          item['Ocupación'] = centersInfo.avg_attendance.avg_attendance[att][key]
          }
          item['Asistencia'] = centersInfo.avg_attendance.avg_attendance[att][key]
        })
        data.push(item)
      })
      this.setState({ data })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  download = () => {
    if (this.props.fromCenter) {
      this.props.getCentersExcel('attendance/average', this.props.activeCenter)
    } else {
      this.props.getAverageAttendanceExcel()
    }
  }


  render() {
    const { attendance, centersInfo } = this.props
    const { width, data } = this.state
    return (
      <ReportTemplate
        title="Asistencia Promedio vs Ocupación Promedio"
        date={((attendance.avg_attendance || centersInfo) && data[0]) &&
          { initial: data[0].date, end: data[data.length - 1].date }}
        onClick={this.download}
        loading={!data[0]}
      >
        {data[0] &&
          <AreaChart
            width={width < 763 ? 400 : 648}
            height={width < 763 ? 300 : 400}
            data={data}
            margin={{ top: 40, right: 50, left: 10, bottom: 40 }}
          >
            <CartesianGrid vertical={false} />
            <XAxis dataKey="formatDay" />
            <YAxis />
            <Tooltip />
            <Legend content={<CustomizedLegend />} />
            <ReferenceLine y={attendance.capacity || centersInfo.avg_attendance.capacity} label={"Capacidad Maxima: " + attendance.capacity || centersInfo.avg_attendance.capacity} stroke="red"/>
            <Area type="monotone" dataKey="Asistencia" stroke="#bb4ab7" fill="#bb4ab7" />
            <Area type="monotone" dataKey="Ocupación" stroke="#2A517F" fill="#2A517F" />
          </AreaChart>
        }
      </ReportTemplate>
    )
}
}


const mapStateToProps = ({ averageAttendance, centersInfo }) => ({
  attendance: averageAttendance.get.results,
  centersInfo: centersInfo.attendance.results,
  activeCenter: centersInfo.center,
})

const mapDispatchToProps = dispatch => ({
  getAverageAttendance: () => dispatch(AverageAttendanceActions.getRequest({}, true)),
  getAverageAttendanceExcel: () => dispatch(AverageAttendanceActions.AverageAttendanceExcelRequest()),
  getCentersExcel: (path, centerId) => dispatch(CentersExcelActions.CentersExcelRequest(path, centerId)),
  getCentersInfo: (id, path) => dispatch(CentersInfoActions.getCentersInfoRequest(id, path)),
  setCenter: id => dispatch(CentersInfoActions.setCenter(id)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AvgAttendance))



// WEBPACK FOOTER //
// ./src/Containers/Reports/AvgAttendance.jsx